/** * @author ❤️❤️❤️ FightFastest 🤎🤎🤎 * @date 🚙 🚒 🛺 8/3/2022 下午 3:48 下午 1:57 🚌🚄🚈🚝 */

<template>
	<div class="info">
		<div class="title">{{title}}:</div>
		<span v-html="info" class="title-info"></span>
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: 'temp',
	props: {
		info: String,
		title: {
			type: String,
			default: '您好'
		}
	},
	data() {
		return {}
	}
}
</script>

<style scoped lang="less">
.info {
	padding: 10px 15px;
	box-sizing: border-box;
	.title {
		font-size: 18px;
		padding-bottom: 5px;
	}
	.title-info {
		font-size: 16px;
		line-height: 25px;
	}
}
</style>
